import React from 'react';
import { useNavigate } from 'react-router-dom';
import { OrderNotification } from '@app/contexts/OrderNotificationContext';
import * as S from './NotificationsOverlay.styles';
import { BaseRow } from '@app/components/common/BaseRow/BaseRow';
import { BaseCol } from '@app/components/common/BaseCol/BaseCol';
import { BaseSpace } from '@app/components/common/BaseSpace/BaseSpace';
import { ShoppingCartOutlined } from '@ant-design/icons';
import moment from 'moment-timezone';

interface NotificationsOverlayProps {
  notifications: OrderNotification[];
  markAsRead: (id: string) => void;
  markAllAsRead: () => void;
}

export const NotificationsOverlay: React.FC<NotificationsOverlayProps> = ({
  notifications,
  markAsRead,
  markAllAsRead,
  ...props
}) => {
  const navigate = useNavigate();

  const handleNotificationClick = (notification: OrderNotification) => {
    markAsRead(notification.id);
    navigate('/admin/deliveries/list');
  };

  const noticesList = notifications.map((notification, index) => (
    <div
      key={notification.id}
      onClick={() => handleNotificationClick(notification)}
      style={{
        padding: '10px 12px',
        cursor: 'pointer',
        borderRadius: '8px',
        backgroundColor: notification.isRead ? 'transparent' : 'rgba(24, 144, 255, 0.06)',
        transition: 'background-color 0.2s',
      }}
      onMouseEnter={(e) => {
        (e.currentTarget as HTMLDivElement).style.backgroundColor = 'rgba(0,0,0,0.04)';
      }}
      onMouseLeave={(e) => {
        (e.currentTarget as HTMLDivElement).style.backgroundColor = notification.isRead
          ? 'transparent'
          : 'rgba(24, 144, 255, 0.06)';
      }}
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
        <ShoppingCartOutlined
          style={{
            fontSize: '1.25rem',
            color: notification.isRead ? '#999' : '#1890ff',
            marginTop: '2px',
          }}
        />
        <div style={{ flex: 1 }}>
          <div
            style={{
              fontWeight: notification.isRead ? 400 : 600,
              fontSize: '0.875rem',
              color: notification.isRead ? '#666' : '#141414',
            }}
          >
            New Order #{notification.orderId}
          </div>
          <div style={{ fontSize: '0.8rem', color: '#888', marginTop: '2px' }}>
            {notification.customerName} — ₹{notification.amount}
          </div>
          <div style={{ fontSize: '0.75rem', color: '#aaa', marginTop: '4px' }}>
            {moment(notification.createdAt).tz('Asia/Kolkata').fromNow()}
          </div>
        </div>
        {!notification.isRead && (
          <div
            style={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              backgroundColor: '#1890ff',
              marginTop: '6px',
              flexShrink: 0,
            }}
          />
        )}
      </div>
    </div>
  ));

  return (
    <S.NoticesOverlayMenu {...props}>
      <BaseRow gutter={[20, 20]}>
        <BaseCol span={24}>
          {notifications.length > 0 ? (
            <div style={{ maxHeight: '350px', overflowY: 'auto' }}>
              <BaseSpace direction="vertical" size={4} style={{ width: '100%' }}>
                {noticesList}
              </BaseSpace>
            </div>
          ) : (
            <S.Text>No new order notifications</S.Text>
          )}
        </BaseCol>
        <BaseCol span={24}>
          <BaseRow gutter={[10, 10]}>
            {notifications.length > 0 && (
              <BaseCol span={24}>
                <S.Btn type="ghost" onClick={() => markAllAsRead()}>
                  Mark all as read
                </S.Btn>
              </BaseCol>
            )}
          </BaseRow>
        </BaseCol>
      </BaseRow>
    </S.NoticesOverlayMenu>
  );
};
